import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const FieldsWrapper = styled.div`
  width: 100%;
  padding-left: 20px;
  padding-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;


export const Field = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  line-height: 20px;
  font-size: 14px;
  color: #323338;
  margin-right: 20px;

  .MuiFormHelperText-contained {
    margin: 0;
  }

  .title {
    flex-shrink: 0;
    width: 220px;
  }

  .value {
    flex-grow: 1;

    .MuiSkeleton-root {
      max-width: 280px;
    }
  }

  .title-bold {
    font-weight: bold;
    margin-bottom: 5px;
  }
`;
